export default {
  headerTasks: 'Zadania konserwacyjne',
  headerAttachments: 'Załączniki',
  noAssetBlobs: 'Zasób {asset} nie ma żadnej dokumentacji.',
};
